module.exports = __webpack_public_path__ + "static/assets/9df2bc77ac124c3924316e9852945b0c.svg";